import React from 'react';

import { StyleSheet } from 'react-native';

import { Box, BoxProps, withTypography } from 'components/ui';
import { primitive, spacing } from 'styles/constants';

const styles = StyleSheet.create({
  container: {
    backgroundColor: 'white',
    borderBottomColor: primitive.$blackOpacity20,
    borderBottomWidth: 1,
    minHeight: spacing.$40,
    paddingHorizontal: spacing.$3,
    paddingVertical: spacing.$6,
  },
  switchContainer: {
    flex: 1,
    flexDirection: 'row',
    width: '100%',
  },
  leftContainer: {
    flexDirection: 'row',
    width: '50%',
  },
  rightContainer: {
    flexDirection: 'row-reverse',
    padding: spacing.$0_5,
    width: '50%',
  },
  paymentContainer: {
    marginTop: spacing.$5,
  },
});

export const Container = ({ style, ...props }: BoxProps) =>
  React.createElement(Box, { ...props, style: [styles.container, style] });

export const SwitchContainer = ({ style, ...props }: BoxProps) =>
  React.createElement(Box, { ...props, style: [styles.switchContainer, style] });

export const LeftContainer = ({ style, ...props }: BoxProps) =>
  React.createElement(Box, { ...props, style: [styles.leftContainer, style] });

export const RightContainer = ({ style, ...props }: BoxProps) =>
  React.createElement(Box, { ...props, style: [styles.rightContainer, style] });

export const QuickPay = withTypography({
  bold: true,
  fontSize: 'lg',
});

export const PaymentContainer = ({ style, ...props }: BoxProps) =>
  React.createElement(Box, { ...props, style: [styles.paymentContainer, style] });
